import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

let CBS_XID = 'c5b41'

export default function useDataTransform(props, data) {
  let xid = useDataValue({
    context: 'global',
    path: 'currrent_location.xid',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return xid !== CBS_XID ? data.filter(item => item.id !== 'cbs') : data
  }, [data])
}
